export const widgetStateOpenHash = '#widget-state-open';
export const widgetStateCloseHash = '#widget-state-close';

export const mobileWidgetHash = '#mobile-widget';
